import { createFieldValidator } from "../../error/createFieldValidator";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import { FieldKey } from "../types";
import { SignupFlowSlug } from "../constants";

import {
  signupFieldValidations,
  signupFieldNameMap,
} from "./signupFieldValidations";

export const validateSignUpField = createFieldValidator<FieldKey, SignupFlowSlug>(
  useSignupFlowErrorStore.getState(),
  signupFieldValidations,
  signupFieldNameMap,
);
